import type {
  Chart,
  ChartCallbackFunction,
  HTMLDOMElement,
  Options,
  StockChart,
  SVGRenderer as SVGRendererType,
} from "highcharts/highstock"
import { useEffect, useState } from "react"

type ChartCallback = (
  renderTo: string | HTMLDOMElement,
  options: Options,
  callback?: ChartCallbackFunction,
) => Chart
type StockChartCallback = (
  renderTo: string | HTMLDOMElement,
  options: Options,
  callback?: ChartCallbackFunction,
) => StockChart

type Charts = {
  stockChart: StockChartCallback
  chart: ChartCallback
  SVGRenderer: SVGRendererType
}

let highcharts: Promise<Charts>

// Dynamically fetch highcharts as it's used in a useEffect and not need to be part of initial bundle
function getHighcharts(): Promise<Charts> {
  if (!highcharts) {
    highcharts = import(/* webpackPreload: true */ "highcharts/highstock").then((Highcharts) => {
      return {
        stockChart: Highcharts.stockChart,
        chart: Highcharts.chart,
        SVGRenderer: Highcharts.SVGRenderer,
      } as unknown as Charts
    })
  }

  return highcharts
}

export type { Options }

// Type-only namespace re-export so app code can reference Highcharts types
// without importing the highcharts package (restricted by lint in frontend).
export type * as Highcharts from "highcharts"

export const useHighcharts = () => {
  const [highchartsInstance, setHighchartInstance] = useState<Charts>()

  useEffect(() => {
    getHighcharts().then((highchart) => setHighchartInstance(highchart))
  }, [])

  return highchartsInstance
}
